import {observer} from "mobx-react";
import React from "react";
import {useBetween} from "use-between";
import ModalInformationReport from "@dropDesk/presentation/components/modals/modal_information_report";
import {UserEntity} from "@dropDesk/domain/entities/user/user.entity";
import {ClientEntity} from "@dropDesk/domain/entities/client/client.entity";
import {SectorEntity} from "@dropDesk/domain/entities/sector/sector.entity";
import {
    useModalsReportTicket
} from "@dropDesk/presentation/pages/reports/report_ticket_init/report_ticket/ui/modals/handle_change_visible";
import {UserRole} from "@dropDesk/domain/entities/user/user_enum";
import ModalSearchUser from "@dropDesk/presentation/components/modals/modal_search_user";
import ModalSearchClient from "@dropDesk/presentation/components/modals/modal_search_client";
import ModalSearchSector from "@dropDesk/presentation/components/modals/modal_search_sector";
import ModalInformation from "@dropDesk/presentation/components/modals/modal_information";
import {RoutesEnum} from "@dropDesk/domain/entities/routes/routes_enum";
import ModalExport from "@dropDesk/presentation/components/modals/modal_information";
import {useNavigate} from "react-router-dom";
import toastMessage from "@dropDesk/utils/toast_message/toast_message";
import {ICONS_DROPDESK} from "@dropDesk/storage/icons/icons.d";


const ModalsReportTicket = observer(
    ({
         loading,
         exportPdf,
         period,
         idSector,
         idClient,
         idUser
     }: {
         exportPdf: () => void,
         loading: boolean,
         period: Array<Date> | null;
         idSector: string | null;
         idClient: string | null;
         idUser: string | null;
     }
    ) => {

        const {
            visibleModalSearchClient, setVisibleModalSearchClient,
            visibleModalInformationReport, setVisibleModalInformationReport,
            textHeaderModalInformationReport,
            textInformationBody,
            textInformationHeader,
            visibleModalExportPdf, setVisibleModalExportPdf,
            visibleModalExport, setVisibleModalExport
        } = useBetween(useModalsReportTicket);

        const navigate = useNavigate();

        return (
            <>
                <ModalInformationReport
                    open={visibleModalInformationReport}
                    onRequestClose={() => {
                        setVisibleModalInformationReport(false)
                    }}
                    textHeaderModal={textHeaderModalInformationReport}
                    textButton={'OK'}
                    onRequestSave={async () => {
                        setVisibleModalInformationReport(false);
                    }}
                    textInformationHeader={textInformationHeader}
                    textInformationBody={textInformationBody}
                    loading={loading}
                />

                <ModalInformation
                    open={visibleModalExportPdf}
                    onRequestClose={() => {
                        setVisibleModalExportPdf(false);
                    }}
                    textHeaderModal={'Exportar gráficos'}
                    textButton={'Exportar'}
                    onRequestSave={async () => {
                        exportPdf();
                        setVisibleModalExportPdf(false);
                    }}
                    nameIcon={ICONS_DROPDESK.pdf}
                    sizeIcon={115}
                    textInformation={`Deseja realmente exportar os gráficos do relatório para um arquivo PDF?`}
                    loading={loading}
                />
                <ModalExport
                    open={visibleModalExport}
                    onRequestClose={() => {
                        setVisibleModalExport(false);
                    }}
                    textHeaderModal={'Exportar atendimentos'}
                    textButton={'Exportar'}
                    onRequestSave={() => {
                        if (period && period[0] && period[1]) {
                            const searchParam =
                                idClient ? `?idClient=${idClient}` :
                                    idUser ? `?idUser=${idUser}` :
                                        idSector ? `?idSector=${idSector}` : '';
                            navigate(`${RoutesEnum.exportreporttickets}${searchParam}`);
                        } else {
                            toastMessage.error("Você deve informar um período de exportação.")
                        }
                        setVisibleModalExport(false);
                    }}
                    nameIcon={ICONS_DROPDESK.excel}
                    sizeIcon={120}
                    textInformation={
                        `Deseja realmente exportar todos os dados dos atendimentos para uma planilha?`
                    }
                    loading={loading}
                />
            </>
        )
    })
export default ModalsReportTicket;
